<template>
  <div class="number-counter">
    <div>
      <span class="number">{{ animatedNumber.toFixed(0) }}</span
      ><span class="dec">{{ dec }}</span
      ><span></span>
    </div>
    <br />
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "NumberCounter",
  props: {
    label: {
      type: String,
      required: true,
    },
    dec: {
      type: String,
      required: true,
    },
    targetNumber: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 2000, // 动画持续时间，单位毫秒
    },
  },
  data() {
    return {
      animatedNumber: 0,
      animationFrameId: null,
      isInView: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(); // 初始检查
  },
  beforeDestroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const rect = this.$el.getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      // 如果组件进入视口
      if (rect.top <= windowHeight && rect.bottom >= 0 && !this.isInView) {
        this.isInView = true;
        this.startAnimation();
      }
    },
    startAnimation() {
      const startTime = performance.now();
      const targetNumber = this.targetNumber;

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / this.duration, 1);
        this.animatedNumber = targetNumber * progress;

        if (progress < 1) {
          this.animationFrameId = requestAnimationFrame(animate);
        }
      };

      this.animationFrameId = requestAnimationFrame(animate);
    },
  },
};
</script>

<style scoped>
.number-counter {
  width: 100%;
  color: #000;
}

.label {
  margin-right: 10px;
  font-size: 18px;
}

.number {
  font-size: 60px;
  font-weight: bold;
  color: #ca391b;
}
.dec {
  color: #ca391b;
}
</style>